import React from 'react';
import classNames from 'classnames';
import CvssService from '~/utils/CvssService';
import Helpers from '~/utils/Helpers';
import StringService from '~/utils/StringService';

type SeverityFlag2Props = {
  isCvss3: boolean;
  cvssScore?: number;
  cvssVector?: string;
  severityLevel?: string;
  showVector?: boolean;
};
const SeverityFlag2: React.SFC<SeverityFlag2Props> = props => {
  const { isCvss3 = false, cvssScore, cvssVector, severityLevel, showVector = true } = props;
  const formattedVector = cvssVector ? StringService.stripParens(cvssVector) : '';
  let cvssVectorLevel = '';
  if (cvssScore) {
    cvssVectorLevel = isCvss3
      ? CvssService.getCvss3Severity(cvssScore)
      : CvssService.getCvssSeverity(cvssScore);
  } else if (severityLevel) {
    cvssVectorLevel = severityLevel;
  }
  const severityClass = classNames({
    'bg-color--danger--dark': isCvss3 && cvssVectorLevel === 'Critical',
    'bg-color--danger': cvssVectorLevel === 'High',
    'bg-color--warning': cvssVectorLevel === 'Medium',
    'bg-color--warning-light': cvssVectorLevel === 'Low',
  });
  const borderColorBySeverity = classNames({
    'border-color--danger--dark': isCvss3 && cvssVectorLevel === 'Critical',
    'border-color--danger': cvssVectorLevel === 'High',
    'border-color--warning': cvssVectorLevel === 'Medium',
    'border-color--warning-light': cvssVectorLevel === 'Low',
  });
  return (
    <div>
      <div className="flex">
        <span
          className={`flex flex--align-self--center ${severityClass} pv-- ph- font--h6 font-family--body color--white text--center`}
        >
          {cvssScore ? (
            cvssScore
          ) : (
            <i className={`color--white text--center sci pv-- sci__vulnerability`} />
          )}
        </span>

        <span
          className={`flex align-items--center bo--1 bo-l--0 ph-- font-family--heading color--black bg-color--white ${borderColorBySeverity}`}
        >
          {`${cvssVectorLevel} (CVSS ${isCvss3 ? 'v3' : 'v2'})`}
        </span>
      </div>

      {showVector && cvssVector && (
        <div className="pt--">
          <span
            className="font--12"
            dangerouslySetInnerHTML={Helpers.formatBreakOnSlash(formattedVector)}
          />
        </div>
      )}
    </div>
  );
};
export default SeverityFlag2;
